module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Peckham, Craig G. Bartholomew\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John C. Peckham ")]), _vm._v("is associate professor of theology and Christian philosophy at the Theological Seminary of Andrews University, Berrien Springs, Michigan. He is also the author of "), _c('I', [_vm._v("The Love of God: A Canonical Model.")]), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FPiTCm/tc-custom/9781467446198.jpg?1728851792828",
      "alt": "This image is the cover for the book Canonical Theology"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Canonical Theology\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What are the roles of canon and community in the understanding and articulation of Christian doctrine? Should the church be the doctrinal arbiter in the twenty-first century? In "), _c('i', [_vm._v("Canonical Theology")]), _vm._v(" John Peckham tackles this complex, ongoing discussion by shedding light on issues surrounding the biblical canon and the role of the community for theology and practice."), _c('br'), _c('br'), _vm._v(" Peckham examines the nature of the biblical canon, the proper relationship of Scripture and tradition, and the interpretation and application of Scripture for theology. He lays out a compelling canonical approach to systematic theology — including an explanation of his method, a step-by-step account of how to practice it, and an example of what theology derived from this canonical approach looks like.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0